var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v(" Du har tilgang til alle wrike Brukere. Menyen vises ovenfor. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }